import { shouldShowDummyFeatures } from './dummy-feature-visibility-policy.mjs'

export function shouldShowLlmChatButton(mode) {
  return shouldShowDummyFeatures(mode)
}

export function getProjectNavbarToolsRightOffset(mode) {
  // CS 문의는 모든 환경에서 표시되고, AI 버튼(40px)만 환경별로 숨겨진다.
  return shouldShowLlmChatButton(mode) ? '238px' : '198px'
}
